<template>
  <g transform="matrix(1,0,0,1,0,0)">
    <path
      d="M5.25 14.248L5.25 18.748 0.75 18.748"
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
    <path
      d="M18.75 9.748L18.75 5.248 23.25 5.248"
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
    <path
      d="M19.032,5.245A9.752,9.752,0,0,1,8.246,21"
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
    <path
      d="M4.967,18.751A9.753,9.753,0,0,1,15.754,3"
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
  </g>
</template>

<script>
const IconMixin = require("@/mixins/IconMixin").default;

export default {
  name: "IconRetry",
  mixins: [IconMixin],
  data() {
    return {};
  },
  props: {},
  computed: {}
};
</script>